import { render, staticRenderFns } from "./ConflictDialog.vue?vue&type=template&id=4bc6332e&scoped=true"
import script from "./ConflictDialog.vue?vue&type=script&lang=js"
export * from "./ConflictDialog.vue?vue&type=script&lang=js"
import style0 from "./ConflictDialog.vue?vue&type=style&index=0&id=4bc6332e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6332e",
  null
  
)

export default component.exports